import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { ProgramViewModalComponent } from './program-view-modal/program-view-modal.component';
import { Subject, from } from 'rxjs';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { AvailableProductsComponent } from '../available-products/available-products.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UntypedFormGroup, UntypedFormControl, FormGroup, FormBuilder } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { Module } from 'src/app/models/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.scss']
})
export class ProgramComponent implements OnInit {

  collapesedOrNot: boolean;
  columnDefs: any[];
  operations: any[];
  tempoperations: any[];
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ProgramSearch: UntypedFormGroup;
  Statuslist: any = [];
  Supportlist: any = [];
  modulelist: any[] = [];
  productlist: any = [];
  isSettings:boolean=false;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) { }

  ngOnInit() {
  
  
     this.Statuslist = [
       { "value":"","label":"All"},
       { "value": "1", "label": "Active" },
       { "value": "0", "label": "Inactive" }

     ];
   
      this.getModulesList();
      this.availableProducts();
    this.ProgramSearch = new UntypedFormGroup({
      Name: new UntypedFormControl(""),
      Supports: new UntypedFormControl(""),
      ProductName: new UntypedFormControl(""),
      RecordStatus: new UntypedFormControl(""),
      MAPPED_PRODUCTS: new UntypedFormControl(""),
      MODULE_ID: new UntypedFormControl(""),
    });
    this.columnDefs = [
      
      {
        "headerName": "Program Category",
        "field": "NAME"
      },
      {
        "headerName": "Program",
        "field": "PROGRAM_ID"
      },
      {
        "headerName": "Application Type",
        "field": "MappedAppTypesNames"
      },
      {
        "headerName": "Type",
        "field": "SUPPORTS"
      },

      {
        "headerName": "Status",
        "field": "RecordStatus"
      }
    ];

    this.tempoperations = [];
    

    if (this.commonService.getScreenPermission("604", "V")) {
      this.isSettings=true;
      this.tempoperations.push({
        "name": "View",
        "id": "View"
      });
    }

    if (this.commonService.getScreenPermission("604", "N")) {
      this.tempoperations.push({
        "name": "Add Program Category",
        "id": "Add"
      });
    }

    if (this.commonService.getScreenPermission("604", "E")) {
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Edit",
        "id": "Edit"
      });
    }

    if (this.commonService.getScreenPermission("604", "D")) {
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Delete",
        "id": "Delete"
      });
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.advanceSearch = {
      "fields": [
        {
          "label": "Name",
          "field": "Name",
          "type": "text"
        },
        {
          "label": "Product",
          "field": "Products",
          "type": "text"
        },
        {
          "label": "Supports",
          "field": "Supports",
          "type": "dropdown",
         
        },
        {
          "label": "Status",
          "field": "Status",
          "type": "dropdown",
          "options": [
            { "value": "1", "label": "Active" },
            { "value": "0", "label": "Inactive" }
          ]
        }
      ]
    }

    this.GetSummary();
    this.ProgramSearch.controls['Supports'].disable();
  }

  getSearchData(searchObject) {
    this.summaryService.AdvanceSearch('api/AdminProgram/AdvanceSearch', searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  onAdvanceSearchOperation(searchFiletrs) {
    switch (searchFiletrs["OperationType"]) {
      case "viewall":
        this.SearchClear();
        this.GetSummary();
        break;
      case "search":
        var searchObject = new Object();
        searchObject["Name"] = searchFiletrs["Name"];
        searchObject["ProductName"] = searchFiletrs["Product"];
        searchObject["MODULE_ID"]=searchFiletrs["MODULE_ID"];
        searchObject["Supports"] = searchFiletrs["Supports"];
        searchObject["RecordStatus"] = searchFiletrs["RecordStatus"];
        this.getSearchData(searchObject);
        break;
    }
  }
  public onOptionsSelected(event) {
    this.Supportlist = [{label : "All" , value : "All"},{label:"Product" , value :"Product"}, 
    {label:"Fund" , value :"Fund"}];
   // console.log(event, event.target.value);
    this.ProgramSearch.controls['Supports'].disable();
     if(event.value == "")
    {
       this.Supportlist =[]; 
    }
    if (event.value == "2") {
      this.ProgramSearch.controls['Supports'].enable();
      setTimeout(() => {
        this.ProgramSearch.controls['Supports'].setValue("All");
    }, 500);
      
    }
    if (event.value == "5") {
      this.Supportlist = [{label:"Product" , value : "Product"}];
      this.ProgramSearch.controls['Supports'].enable();
    
      this.ProgramSearch.controls['Supports'].setValue("Product");

    }
    if (event.value == "4") {
      this.Supportlist = [{label:"Fund" , value :"Fund"}];
      this.ProgramSearch.controls['Supports'].enable();
      
      this.ProgramSearch.controls['Supports'].setValue("Fund");
    }

  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef=this['self'].modalService.open(ProgramViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'] }
    }
  }



  Add() {
    let modalRef = this['self'].modalService.open(ProgramViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "" }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }


  Edit(Record:any) {
   
    let modalRef = this['self'].modalService.open(ProgramViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }

  View(Record: any) {
   
     const modelRef=this['self'].modalService.open(ProgramViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: 'View',
      content: { id: Record['ID'] }
    }
  }

  
  getModulesList(): void {
 //   
    this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
      this.modulelist = result;
      this.modulelist = [{label : "All" , value  : ""}].concat(this.modulelist);

     // console.log(this.modulelist)
    });
  }

  GetSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData('api/AdminProgram/GetSummaryData').subscribe(summary => {
      this.rowData = summary;
      //console.log(this.rowData)
    });
  }

  Delete(Record: any) {
    let id = Record['ID'];
    let name = Record['NAME'];
    let message = "";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content={ heading: 'Delete', 
    custommessage: 'Are you sure you want to delete the Program Category   ' +"'" + name + "'" + ' ?',
     ProceedButtonName: "Delete", 
     TerminateButtonName: "Cancel" }
    modalRef.result.then(result => {
      if (result == "okclick")
        this["self"].summaryService.Delete('api/AdminProgram/Delete?RecordID=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
            this["self"].commonService.SuccessBanner(summary.Message);
            //toastrService.success("Selected Record(s) has been Deleted");
            this['self'].GetSummary();
          }
          else {
            this["self"].commonService.ValidationBanner(summary.Message);
          
          }

       });

    })

  };
  availableProducts(){
  
    this.summaryService.getSummaryData('api/Product/GetProductsAvaliable').subscribe((result) => {
      this.productlist = result;
      this.productlist=[{label : "All" , value: ""}].concat(this.productlist);
    });
  }

  Active(service) {
    let id = this['self'].selectedRow['ID'];
    service.setActive('api/AdminProgram/Active?RecordID=' + id).subscribe(summary => {
      this["self"].commonService.SuccessBanner("Selected Records has been made Active");
      this['self'].GetSummary();
    });
  }

  Inactive(service) {
    let id = this['self'].selectedRow['ID'];
    service.setInActive('api/AdminProgram/InActive?RecordID=' + id).subscribe(summary => {
      this["self"].commonService.SuccessBanner("Selected Records has been made Inactive");
      this['self'].GetSummary();
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.ProgramSearch.patchValue({
      Name: "",
      Supports: "",
      ProductName: "",
      RecordStatus: "",
      MAPPED_PRODUCTS: "",
      MODULE_ID: "",
    });
    this.Supportlist =[]; 
    this.ProgramSearch.controls['Supports'].disable();
  }
  AdvanceSearch() {
    var formData = this.ProgramSearch.value;
    this.getSearchData(formData);
  }
}
